import { showApiErrors } from '@/utils';
import { createSlice, isFulfilled, isPending, isRejected, PayloadAction } from '@reduxjs/toolkit';
import { TGetRedirectsQuery } from '../helpers/types';
import { createMetaTag, deleteMetaTag, getMetaTag, getMetaTags, updateMetaTag } from './actionCreators';
import { initialState, META_TAGS_SLICE_NAME, MetaTagsListState } from './models';

export const slice = createSlice({
  name: META_TAGS_SLICE_NAME,
  initialState,
  reducers: {
    resetMetaTagsState() {
      return initialState;
    },
    changeQuery: (state: MetaTagsListState, action: PayloadAction<TGetRedirectsQuery>) => {
      state.query = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMetaTags.fulfilled, (state: MetaTagsListState, action) => {
        state.metaTagsList = action.payload;
        state.isLoading = false;
      })
      .addMatcher(isFulfilled(createMetaTag, deleteMetaTag, getMetaTag, updateMetaTag), (state: MetaTagsListState) => {
        state.isLoading = false;
      })
      .addMatcher(
        isPending(createMetaTag, deleteMetaTag, getMetaTag, getMetaTags, updateMetaTag),
        (state: MetaTagsListState) => {
          state.isLoading = true;
          state.error = null;
        },
      )
      .addMatcher(
        isRejected(createMetaTag, deleteMetaTag, getMetaTag, getMetaTags, updateMetaTag),
        (state: MetaTagsListState, action) => {
          const { error } = action;
          state.isLoading = false;
          state.error = error;

          showApiErrors(error);
        },
      );
  },
});

export const { resetMetaTagsState, changeQuery } = slice.actions;

export default slice.reducer;
